/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Lms.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckoutSessionResponse,
  CourseModulePlayerDto,
  CoursePlayerDetailDto,
  DiscountCodeRedemptionResponse,
  DiscountCodeRequest,
  DiscountCodeValidationResponse,
  ProblemDetails,
  SubmitEvaluationRequest,
  UpdateModuleCompletionRequest,
  UpdateModuleCompletionResponse
} from '../../../types/api';

import { apiClient } from '../../client/api-client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Receives verified Stripe payment events and grants course entitlements on success
 * @summary Stripe payment webhook
 */
export const learningStripeWebhook = (

 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/learning/webhooks/stripe`, method: 'POST', signal
    },
      );
    }




export const getLearningStripeWebhookMutationKey = () => ['learningStripeWebhook'] as const;

export const getLearningStripeWebhookMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningStripeWebhook>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningStripeWebhook>>, TError,void, TContext> => {

const mutationKey = getLearningStripeWebhookMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningStripeWebhook>>, void> = () => {


          return  learningStripeWebhook()
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningStripeWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof learningStripeWebhook>>>

    export type LearningStripeWebhookMutationError = void


    /**
 * @summary Stripe payment webhook
 */
export const useLearningStripeWebhook = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningStripeWebhook>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningStripeWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLearningStripeWebhookMutationOptions(options), queryClient);
    }
    /**
 * Returns course information for the player page
 * @summary Get course details for player
 */
export const learningGetCourseDetail = (
    courseId: string,
 signal?: AbortSignal
) => {


      return apiClient<CoursePlayerDetailDto>(
      {url: `/api/learning/courses/${courseId}`, method: 'GET', signal
    },
      );
    }




export const getLearningGetCourseDetailQueryKey = (courseId: string,) => {
    return [
    `/api/learning/courses/${courseId}`
    ] as const;
    }


export const getLearningGetCourseDetailQueryOptions = <TData = Awaited<ReturnType<typeof learningGetCourseDetail>>, TError = void>(courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLearningGetCourseDetailQueryKey(courseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof learningGetCourseDetail>>> = ({ signal }) => learningGetCourseDetail(courseId, signal);





   return  { queryKey, queryFn, enabled: courseId !== null && courseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LearningGetCourseDetailQueryResult = NonNullable<Awaited<ReturnType<typeof learningGetCourseDetail>>>
export type LearningGetCourseDetailQueryError = void


export function useLearningGetCourseDetail<TData = Awaited<ReturnType<typeof learningGetCourseDetail>>, TError = void>(
 courseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningGetCourseDetail>>,
          TError,
          Awaited<ReturnType<typeof learningGetCourseDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningGetCourseDetail<TData = Awaited<ReturnType<typeof learningGetCourseDetail>>, TError = void>(
 courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningGetCourseDetail>>,
          TError,
          Awaited<ReturnType<typeof learningGetCourseDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningGetCourseDetail<TData = Awaited<ReturnType<typeof learningGetCourseDetail>>, TError = void>(
 courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get course details for player
 */

export function useLearningGetCourseDetail<TData = Awaited<ReturnType<typeof learningGetCourseDetail>>, TError = void>(
 courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLearningGetCourseDetailQueryOptions(courseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns all modules for a course ordered by display order
 * @summary Get course modules
 */
export const learningGetCourseModules = (
    courseId: string,
 signal?: AbortSignal
) => {


      return apiClient<CourseModulePlayerDto[]>(
      {url: `/api/learning/courses/${courseId}/modules`, method: 'GET', signal
    },
      );
    }




export const getLearningGetCourseModulesQueryKey = (courseId: string,) => {
    return [
    `/api/learning/courses/${courseId}/modules`
    ] as const;
    }


export const getLearningGetCourseModulesQueryOptions = <TData = Awaited<ReturnType<typeof learningGetCourseModules>>, TError = void>(courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseModules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLearningGetCourseModulesQueryKey(courseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof learningGetCourseModules>>> = ({ signal }) => learningGetCourseModules(courseId, signal);





   return  { queryKey, queryFn, enabled: courseId !== null && courseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LearningGetCourseModulesQueryResult = NonNullable<Awaited<ReturnType<typeof learningGetCourseModules>>>
export type LearningGetCourseModulesQueryError = void


export function useLearningGetCourseModules<TData = Awaited<ReturnType<typeof learningGetCourseModules>>, TError = void>(
 courseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseModules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningGetCourseModules>>,
          TError,
          Awaited<ReturnType<typeof learningGetCourseModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningGetCourseModules<TData = Awaited<ReturnType<typeof learningGetCourseModules>>, TError = void>(
 courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseModules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningGetCourseModules>>,
          TError,
          Awaited<ReturnType<typeof learningGetCourseModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningGetCourseModules<TData = Awaited<ReturnType<typeof learningGetCourseModules>>, TError = void>(
 courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseModules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get course modules
 */

export function useLearningGetCourseModules<TData = Awaited<ReturnType<typeof learningGetCourseModules>>, TError = void>(
 courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningGetCourseModules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLearningGetCourseModulesQueryOptions(courseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Submits the course evaluation for the logged in user
 * @summary Submit course evaluation
 */
export const learningSubmitEvaluation = (
    courseId: string,
    submitEvaluationRequest: SubmitEvaluationRequest,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/learning/courses/${courseId}/evaluation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitEvaluationRequest, signal
    },
      );
    }




export const getLearningSubmitEvaluationMutationKey = () => ['learningSubmitEvaluation'] as const;

export const getLearningSubmitEvaluationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningSubmitEvaluation>>, TError,LearningSubmitEvaluationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningSubmitEvaluation>>, TError,LearningSubmitEvaluationMutationVariables, TContext> => {

const mutationKey = getLearningSubmitEvaluationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningSubmitEvaluation>>, LearningSubmitEvaluationMutationVariables> = (props) => {
          const {courseId,data} = props ?? {};

          return  learningSubmitEvaluation(courseId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningSubmitEvaluationMutationResult = NonNullable<Awaited<ReturnType<typeof learningSubmitEvaluation>>>
    export type LearningSubmitEvaluationMutationBody = SubmitEvaluationRequest
    export type LearningSubmitEvaluationMutationError = void
    export type LearningSubmitEvaluationMutationVariables = {courseId: string;data: SubmitEvaluationRequest}

    /**
 * @summary Submit course evaluation
 */
export const useLearningSubmitEvaluation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningSubmitEvaluation>>, TError,LearningSubmitEvaluationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningSubmitEvaluation>>,
        TError,
        LearningSubmitEvaluationMutationVariables,
        TContext
      > => {
      return useMutation(getLearningSubmitEvaluationMutationOptions(options), queryClient);
    }
    /**
 * Creates a Stripe checkout session for the authenticated learner to buy a paid course
 * @summary Start course purchase checkout
 */
export const learningStartCheckout = (
    courseId: string,
 signal?: AbortSignal
) => {


      return apiClient<CheckoutSessionResponse>(
      {url: `/api/learning/courses/${courseId}/checkout`, method: 'POST', signal
    },
      );
    }




export const getLearningStartCheckoutMutationKey = () => ['learningStartCheckout'] as const;

export const getLearningStartCheckoutMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningStartCheckout>>, TError,LearningStartCheckoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningStartCheckout>>, TError,LearningStartCheckoutMutationVariables, TContext> => {

const mutationKey = getLearningStartCheckoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningStartCheckout>>, LearningStartCheckoutMutationVariables> = (props) => {
          const {courseId} = props ?? {};

          return  learningStartCheckout(courseId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningStartCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof learningStartCheckout>>>

    export type LearningStartCheckoutMutationError = void
    export type LearningStartCheckoutMutationVariables = {courseId: string}

    /**
 * @summary Start course purchase checkout
 */
export const useLearningStartCheckout = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningStartCheckout>>, TError,LearningStartCheckoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningStartCheckout>>,
        TError,
        LearningStartCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getLearningStartCheckoutMutationOptions(options), queryClient);
    }
    /**
 * Server-authoritative check that a discount code fully comps a paid course; returns a £0.00 preview without granting access or charging the learner.
 * @summary Validate a discount code for a course
 */
export const learningValidateDiscountCode = (
    courseId: string,
    discountCodeRequest: DiscountCodeRequest,
 signal?: AbortSignal
) => {


      return apiClient<DiscountCodeValidationResponse>(
      {url: `/api/learning/courses/${courseId}/discount-code/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: discountCodeRequest, signal
    },
      );
    }




export const getLearningValidateDiscountCodeMutationKey = () => ['learningValidateDiscountCode'] as const;

export const getLearningValidateDiscountCodeMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningValidateDiscountCode>>, TError,LearningValidateDiscountCodeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningValidateDiscountCode>>, TError,LearningValidateDiscountCodeMutationVariables, TContext> => {

const mutationKey = getLearningValidateDiscountCodeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningValidateDiscountCode>>, LearningValidateDiscountCodeMutationVariables> = (props) => {
          const {courseId,data} = props ?? {};

          return  learningValidateDiscountCode(courseId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningValidateDiscountCodeMutationResult = NonNullable<Awaited<ReturnType<typeof learningValidateDiscountCode>>>
    export type LearningValidateDiscountCodeMutationBody = DiscountCodeRequest
    export type LearningValidateDiscountCodeMutationError = ProblemDetails | void
    export type LearningValidateDiscountCodeMutationVariables = {courseId: string;data: DiscountCodeRequest}

    /**
 * @summary Validate a discount code for a course
 */
export const useLearningValidateDiscountCode = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningValidateDiscountCode>>, TError,LearningValidateDiscountCodeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningValidateDiscountCode>>,
        TError,
        LearningValidateDiscountCodeMutationVariables,
        TContext
      > => {
      return useMutation(getLearningValidateDiscountCodeMutationOptions(options), queryClient);
    }
    /**
 * Redeems a valid full-comp code, granting the same lifetime entitlement as a paid purchase without Stripe, card entry, or a charge.
 * @summary Redeem a discount code to comp a course
 */
export const learningRedeemDiscountCode = (
    courseId: string,
    discountCodeRequest: DiscountCodeRequest,
 signal?: AbortSignal
) => {


      return apiClient<DiscountCodeRedemptionResponse>(
      {url: `/api/learning/courses/${courseId}/discount-code/redeem`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: discountCodeRequest, signal
    },
      );
    }




export const getLearningRedeemDiscountCodeMutationKey = () => ['learningRedeemDiscountCode'] as const;

export const getLearningRedeemDiscountCodeMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningRedeemDiscountCode>>, TError,LearningRedeemDiscountCodeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningRedeemDiscountCode>>, TError,LearningRedeemDiscountCodeMutationVariables, TContext> => {

const mutationKey = getLearningRedeemDiscountCodeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningRedeemDiscountCode>>, LearningRedeemDiscountCodeMutationVariables> = (props) => {
          const {courseId,data} = props ?? {};

          return  learningRedeemDiscountCode(courseId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningRedeemDiscountCodeMutationResult = NonNullable<Awaited<ReturnType<typeof learningRedeemDiscountCode>>>
    export type LearningRedeemDiscountCodeMutationBody = DiscountCodeRequest
    export type LearningRedeemDiscountCodeMutationError = ProblemDetails | void
    export type LearningRedeemDiscountCodeMutationVariables = {courseId: string;data: DiscountCodeRequest}

    /**
 * @summary Redeem a discount code to comp a course
 */
export const useLearningRedeemDiscountCode = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningRedeemDiscountCode>>, TError,LearningRedeemDiscountCodeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningRedeemDiscountCode>>,
        TError,
        LearningRedeemDiscountCodeMutationVariables,
        TContext
      > => {
      return useMutation(getLearningRedeemDiscountCodeMutationOptions(options), queryClient);
    }
    /**
 * Updates module completion progress and recalculates course progress
 * @summary Update module completion
 */
export const learningUpdateModuleCompletion = (
    courseId: string,
    moduleId: string,
    updateModuleCompletionRequest: UpdateModuleCompletionRequest,
 signal?: AbortSignal
) => {


      return apiClient<UpdateModuleCompletionResponse>(
      {url: `/api/learning/courses/${courseId}/modules/${moduleId}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateModuleCompletionRequest, signal
    },
      );
    }




export const getLearningUpdateModuleCompletionMutationKey = () => ['learningUpdateModuleCompletion'] as const;

export const getLearningUpdateModuleCompletionMutationOptions = <TError = void | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningUpdateModuleCompletion>>, TError,LearningUpdateModuleCompletionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningUpdateModuleCompletion>>, TError,LearningUpdateModuleCompletionMutationVariables, TContext> => {

const mutationKey = getLearningUpdateModuleCompletionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningUpdateModuleCompletion>>, LearningUpdateModuleCompletionMutationVariables> = (props) => {
          const {courseId,moduleId,data} = props ?? {};

          return  learningUpdateModuleCompletion(courseId,moduleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearningUpdateModuleCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof learningUpdateModuleCompletion>>>
    export type LearningUpdateModuleCompletionMutationBody = UpdateModuleCompletionRequest
    export type LearningUpdateModuleCompletionMutationError = void | ProblemDetails
    export type LearningUpdateModuleCompletionMutationVariables = {courseId: string;moduleId: string;data: UpdateModuleCompletionRequest}

    /**
 * @summary Update module completion
 */
export const useLearningUpdateModuleCompletion = <TError = void | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningUpdateModuleCompletion>>, TError,LearningUpdateModuleCompletionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningUpdateModuleCompletion>>,
        TError,
        LearningUpdateModuleCompletionMutationVariables,
        TContext
      > => {
      return useMutation(getLearningUpdateModuleCompletionMutationOptions(options), queryClient);
    }
